<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

  <div></div>
</template>
<style scoped></style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rename",
  mixins: [bus_common],
  data: function () {
    return {
      item: "fish",
    };
  },
  watch: {},
  computed: {},
  methods: {
    init: function () {},
  },
  mounted() {
    this.$nextTick(() => {
      this.show_loader(false);
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped>
@media (min-width: 0) {
}

@media (min-width: 768px) {
}
</style>
